// extracted by mini-css-extract-plugin
module.exports = {"game":"style_game__xvZxc","gameActive":"style_gameActive__3zyqF","name":"style_name__PD7XA","league":"style_league__3aIGr"};